import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  baseProfile: "full"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#1b4d56\" d=\"M1.48 18.627v-5.375h.48v5.375z\"></path><path fill=\"#1b4d56\" d=\"M13.767 18.635H1.719v-.48h12.048z\"></path><path fill=\"#14988a\" d=\"m3.88 15.94.631-7.802h1.697l1.436 4.42q.136.385.273.83.136.446.235.867h.025q.111-.433.241-.873t.254-.823l1.412-4.421h1.696l.657 7.802h-1.3l-.273-3.765q-.05-.632-.074-1.331-.025-.7-.038-1.344h-.024q-.161.644-.36 1.331-.198.688-.408 1.307L8.722 15.94h-1.14l-1.25-3.815q-.211-.644-.397-1.294T5.576 9.5h-.025q-.012.644-.056 1.35-.043.706-.092 1.325l-.248 3.765Z\"></path><path fill=\"#1b4d56\" d=\"M14.513 15.94V8.06h4.878v1.076h-3.54v2.176h3.214v1.063h-3.214v2.489h3.577v1.076ZM22.38 5.373v5.375h-.48V5.373z\"></path><path fill=\"#1b4d56\" d=\"M10.093 5.365H22.14v.48H10.093z\"></path>", 5)
  ]))]))
}
export default { render: render }